import apiClient from './client';

export interface Feedback {
  id: string;
  user_id: string;
  telegram_user_id: number;
  subject?: string;
  message: string;
  rating?: number;
  created_at: string;
  updated_at: string;
}

export interface CreateFeedbackRequest {
  subject?: string;
  message: string;
  rating?: number;
}

/** Обращение в списке (переписка, редизайн). */
export interface FeedbackThreadSummaryDTO {
  id: string;
  subject: string;
  status: string;
  created_at: string;
  last_at: string;
  last_from: 'user' | 'support';
  last_text: string;
  unread: number;
}

export interface FeedbackMessageDTO {
  id: string;
  from: 'user' | 'support';
  text: string;
  channel?: 'telegram' | 'max' | 'app';
  platform?: 'web' | 'telegram' | 'max';
  notify_channel?: 'telegram' | 'max' | 'app';
  notify_status?: 'pending' | 'sent' | 'failed' | 'not_needed';
  read_at?: string;
  created_at: string;
}

export interface FeedbackThreadDTO {
  id: string;
  subject: string;
  status: string;
  created_at: string;
  messages: FeedbackMessageDTO[] | null;
}

export const feedbackApi = {
  /** Мои обращения, свежие по последнему сообщению первыми. */
  listThreads: async (): Promise<FeedbackThreadSummaryDTO[] | null> => {
    const response = await apiClient.get<FeedbackThreadSummaryDTO[] | null>('/feedback/threads');
    return response.data;
  },

  /** Переписка целиком; чужое или несуществующее - 404. */
  getThread: async (id: string): Promise<FeedbackThreadDTO> => {
    const response = await apiClient.get<FeedbackThreadDTO>(`/feedback/threads/${id}`);
    return response.data;
  },

  /** Новое обращение из приложения. platform - где открыто: web, telegram, max. */
  createThread: async (message: string, platform: string): Promise<FeedbackThreadDTO> => {
    const response = await apiClient.post<FeedbackThreadDTO>('/feedback/threads', { message, platform });
    return response.data;
  },

  /** Ответ в свою переписку. */
  reply: async (id: string, message: string, platform: string): Promise<FeedbackMessageDTO> => {
    const response = await apiClient.post<FeedbackMessageDTO>(`/feedback/threads/${id}/messages`, { message, platform });
    return response.data;
  },

  /** Ответы поддержки прочитаны. */
  markRead: async (id: string): Promise<{ marked: number }> => {
    const response = await apiClient.post<{ marked: number }>(`/feedback/threads/${id}/read`);
    return response.data;
  },

  /**
   * Создать обращение в обратную связь
   */
  create: async (data: CreateFeedbackRequest): Promise<Feedback> => {
    const response = await apiClient.post<Feedback>('/feedback', data);
    return response.data;
  },

  /**
   * Получить историю обращений пользователя
   */
  getUserFeedback: async (userId: string): Promise<Feedback[]> => {
    const response = await apiClient.get<Feedback[]>(`/users/${userId}/feedback`);
    return response.data;
  },
};
